import { DecisionsOnPackages } from '../Enums/DecisionOnPackages';

export interface ParticipationListItem {
  id: string;
  conversionProjectId?: string | null;
  projectName?: string;
  ansokanId: string;
  ansokanNumber: string;
  participantFullname: string;
  participantPersonalNumber: string;
  participantPhone: string;
  participantMobilePhone: string;
  participantEmail: string;
  participantAddress: string;
  participantCoAddress: string;
  participantCity: string;
  participantPostalCode: string;
  frameworkAgreement: string;
  coachId?: string | null;
  coachFullname: string;
  statusForCoach: StatusForCoach;
  statusForCoachText: string;
  worksiteOrganizationName: string;
  worksiteOrgAddress: string;
  worksiteOrgCity: string;
  worksiteOrgPostalCode: string;
  projectStartDate?: string | null;
  signDate?: string | null;
  participantTilldelningsdatum?: string | null;
  participantDeltagarId: string;
  berattigadTillStod?: BerattigadTillStod | null;
  berattigadTillStodText?: string | null;
  participantStartDate?: string | null;
  participantEndReportDate?: string | null;
  protectedIdentity: boolean;
  participantKommun: string;
  participantLan: string;
  otherNoteToCoach: string;
  meetingsCount?: number;
  decisionOnPackage?: DecisionsOnPackages[];
  decionOnPackageText?: string;
}
export enum StatusForCoach {
  Empty = 0,
  NewParticipant = 1,
  CoachAssigned = 2,
  StartDateSet = 3,
  NewDecisionRequested = 4,
  NewSupportApproved = 5,
  RejectNewSupport = 6,
  EndReported = 7,
}

export const StatusForCoachText: { [key in StatusForCoach]: string } = {
  [StatusForCoach.Empty]: 'Okänd',
  [StatusForCoach.NewParticipant]: 'Ny deltagare',
  [StatusForCoach.CoachAssigned]: 'Coach tilldelad',
  [StatusForCoach.StartDateSet]: 'Startdatum satt',
  [StatusForCoach.NewDecisionRequested]: 'Nytt beslut begärt',
  [StatusForCoach.NewSupportApproved]: 'Nytt stöd godkänt',
  [StatusForCoach.RejectNewSupport]: 'Avslag nytt stöd',
  [StatusForCoach.EndReported]: 'Slutrapporterad',
};

export enum BerattigadTillStod {
  Ja = 1,
  AvvaktarKomplettering = 2,
  Avslag = 3,
  Dubblett = 4,
}

export const BerattigadTillStodText: { [key in BerattigadTillStod]: string } = {
  [BerattigadTillStod.Ja]: 'Ja',
  [BerattigadTillStod.AvvaktarKomplettering]: 'Avvaktar komplettering',
  [BerattigadTillStod.Avslag]: 'Avslag',
  [BerattigadTillStod.Dubblett]: 'Dubblett',
};
